/**
 * @engine/graph — registration bootstrap helper
 *
 * Every node-based system needs a "register all built-in nodes once" entry point
 * that is safe to call repeatedly (the editor, compiler, and runtime each want to
 * ensure registration without racing). This captures that idempotent-guard pattern
 * once instead of each package re-implementing a module-level boolean flag.
 *
 * @example
 * export const registerBuiltinVFXNodes = createBootstrap(
 *   () => vfxNodeRegistry.registerAll(ALL_VFX_NODES),
 * );
 */

/**
 * Wrap a one-time side-effecting `register` fn so it runs at most once.
 * Returns a parameterless function; subsequent calls are no-ops.
 */
export function createBootstrap(register: () => void): () => void {
  let done = false;
  return () => {
    if (done) return;
    done = true;
    register();
  };
}
